<template>
  <div>
    <QS-h4-title title="维保图片" />
    <el-form>
      <el-form-item :label="image.label+ columnSeparator" v-for="image in imageList" :key="image.label" class="image-item">
        <EnlargeImg v-for="item in image.value" :imgSrc="item" :key="item"/>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'maintenancePhoto',
  props: ['imageList'],
}
</script>

<style lang="scss" scoped>
.image-item{
  margin-bottom: 8px;
  ::v-deep .el-form-item__content{
    display: flex;
    flex-wrap: wrap;
    .imgDiv{
      margin-right:15px;
      margin-bottom: 15px;
    }
  }
}
</style>

